angular
  .module("transactionTableDigital.components", ["app.services"])
  .component("transactionTableDigital", {
    templateUrl: "ng/components/transactionTableDigital/transactionTableDigitalNew.view.html",
    controllerAs: "TransactionTableDigitalCtrl",
    bindings: {
      filterSelected: "<",
      mode: "<",
      viewMode: "<",
      actionButtonIsVisible: "<",
      listaPraticheSelezionate: "&",
      portal: "=",
      onObtainingDropdowns: "&",
      startRequestPractice: "<",
      updatePracticesList: "<",
      restPending: '&'
    },
    controller: function (
      $financialService,
      $workflowService,
      $transactionFactory,
      FinancialModel,
      $location,
      $modalService,
      $portalService,
      $arcService,
      $rootScope,
      $timeout,
      $financialApiService,
      RichiestePostVendita,
      $configService,
      $RichiestePostVenditaService,
      $download
    ) {
      var self = this;
      var type = "WF_DIGITAL";


      self.$onChanges = function (changes) {
        if (changes.startRequestPractice && typeof changes.startRequestPractice.currentValue != "undefined") {
          self.supportModel.praticheSelezionate = [];
          self.getListPractice();
        }
        if (changes.filterSelected && typeof changes.filterSelected.currentValue !== "undefined") {
          $transactionFactory.setFilters(changes.filterSelected.currentValue);
          refreshPracticeWithFilters(changes.filterSelected.currentValue);
        } else {
          self.viewMode = 'fiscale';
        }

        if (changes.updatePracticesList && typeof changes.updatePracticesList.currentValue != "undefined") {
          self.getListPractice();
        }
      };

      self.$onInit = function () {
        self.portalService = $portalService;
        self.supportModel = {
          praticheSelezionate: [],
          listaContratti: [],
          listaContrattiDaDuplicare: [],
          contrattoSelezionato: null,
          contrattiSelezionati: []
        }
        self.listOfTransaction = [];
        self.loaderModifica = [];
        self.loaderMonitor = [];
        self.loaderRiprendi = [];
        self.loaderRiprendiPv = [];
        self.loaderDuplica = [];
        self.loaderElimina = [];
        self.loaderDettaglio = [];
        self.loaderViewDocs = [];
        self.loaderRelease = [];
        self.loaderDettaglioPv = [];
        self.loaderTaskFiliale = [];
        self.loaderDuplicaAutorizza = [];
        self.loaderEliminaPv = [];
        self.loaderCopyRequestPv = [];
        self.buttonDisabled = false;
        self.loaderConfirm = false;
        self.isPostVendita = false;
        self.actionSelected = false;
        if ($rootScope.returnToHomeWithFilters) {
          $rootScope.returnToHomeWithFilters = false;
          self.filter = Object.assign({}, $transactionFactory.getFilters());
          refreshPracticeWithFilters($transactionFactory.getFilters());

        } else {
          $rootScope.idPracticeSelected = null;
          switch (self.mode) {
            case 'CTR':
              self.filter = {
                limit: 10,
                offset: 0,
                pageIndex: 1,
                totalPages: 0,
                orderColumnName: "UPDATE_DATE",
                orderType: "DESC",
                status: self.status,
                contract: self.contract,
                product: self.product,
                dataAvvioDa: self.dataAvvioDa,
                dataAvvioA: self.dataAvvioA,
                dataFineDa: self.dataFineDa,
                dataFineA: self.dataFineA
              }

              self.listOfTransaction = [];
              self.loaderDettaglio = [];
              self.buttonDisabled = false;
              self.loaderConfirm = false;
              self.getContractsList();
              break;
            case 'DOC':
              var date = new Date();
              var emissionDateFromDef = moment(date, 'DD/MM/YYYY').subtract(6, 'months').format('DD/MM/YYYY');
              var emissionDateToDef = moment(date).format('DD/MM/YYYY');
              self.filter = {
                limit: 10,
                offset: 0,
                pageIndex: 1,
                totalPages: 0,
                orderColumnName: "UPDATE_DATE",
                orderType: "DESC",
                docCategory: 'fiscale',
                contractServicePojo: self.contractServicePojo,
                docType: self.docType,
                emissionDateFrom: self.emissionDateFrom || emissionDateFromDef,
                emissionDateTo: self.emissionDateTo || emissionDateToDef,
                endDateFrom: self.endDateFrom,
                endDateTo: self.endDateTo,
              }

              self.listOfTransaction = [];
              self.loaderDettaglio = [];
              self.buttonDisabled = false;
              self.loaderConfirm = false;
              //self.getDocumentsList();
              break;
            default:
              self.filter = {
                limit: 10,
                offset: 0,
                pageIndex: 1,
                totalPages: 0,
                orderColumnName: "UPDATE_DATE",
                orderType: "DESC",
                status: self.stateSelected,
                ragSoc: self.ragSocCliente,
                numeroAnno: self.anno,
                numeroPreventivo: self.preventivo,
                numeroContratto: self.contratto,
                idCustomer: self.pIvaCliente,
                endDate: self.endDate,
                startDate: self.startDate,
                id: self.id
              };

              self.getListPractice();
          }
        }
      }

      function updateOffsetAndSearch() {
        self.filter.offset = (self.filter.pageIndex - 1) * self.filter.limit;

        switch (self.mode) {
          case 'CTR':
            self.getContractsList();
            break;
          case 'DOC':
            self.getDocumentsList();
            break;
          default:
            self.getListPractice();
        }
      }

      function refreshPracticeWithFilters(filtro) {
        switch (self.mode) {
          case 'CTR':
            self.filter.status = filtro.status
            self.filter.contract = filtro.contract;
            self.filter.product = filtro.product;
            self.filter.offset = filtro.offset;
            self.filter.dataAvvioDa = filtro.dataAvvioDa;
            self.filter.dataAvvioA = filtro.dataAvvioA;
            self.filter.dataFineDa = filtro.dataFineDa;
            self.filter.dataFineA = filtro.dataFineA;
            self.filter.showAll = filtro.showAll;
            self.filter.modulo = filtro.modulo
            self.getContractsList();
            break;
          case 'DOC':
            self.filter.docCategory = filtro.docCategory;
            self.filter.docType = filtro.docType;
            self.filter.contractServicePojo = filtro.contractServicePojo;
            self.filter.offset = filtro.offset;
            self.filter.refYear = filtro.refYear;
            self.filter.emissionDateFrom = filtro.emissionDateFrom;
            self.filter.emissionDateTo = filtro.emissionDateTo;
            self.filter.endDateFrom = filtro.endDateFrom;
            self.filter.endDateTo = filtro.endDateTo;
            self.filter.pageIndex = filtro.pageIndex;
            self.filter.totalPages = filtro.totalPages;
            self.filter.daLeggere = filtro.daLeggere;
            if (self.filter.daLeggere) {
              filtro.docCategory = null;
            }
            if (filtro.docCategory == 'fiscale') {
              self.viewMode = 'fiscale';
            } else {
              self.viewMode = 'altro';
            }
            self.getDocumentsList();
            break;
          default:
            if (filtro) {
              if (filtro.status) {
                self.filter.status = filtro.status.value;
              } else {
                self.filter.status = undefined;
              }

              self.filter.ragSoc = filtro.ragSoc;
              self.filter.numeroAnno = filtro.numeroAnno;
              self.filter.numeroPreventivo = filtro.numeroPreventivo;
              self.filter.numeroContratto = filtro.numeroContratto;
              self.filter.idCustomer = filtro.idCustomer;
              self.filter.startDate = filtro.startDate;
              self.filter.endDate = filtro.endDate;
              self.filter.offset = filtro.offset;
              self.filter.id = filtro.id;
              self.filter.ndgVendorUser = filtro.ndgVendorUser;
              self.filter.ndgVendorSelected = filtro.ndgVendorSelected;
              self.filter.ndgSegnalatore = filtro.ndgSegnalatore;
              self.filter.ndgCustomer = filtro.ndgCustomer;
              self.filter.categoriaRichiesta = filtro.categoriaRichiesta
              self.filter.tipoRichiesta = filtro.tipoRichiesta;
              self.filter.showAll = filtro.showAll;
              self.filter.showMyArea = filtro.showMyArea;
              self.filter.product = filtro.product;
              self.filter.faseGestionale = filtro.faseGestionale;
              self.filter.cdRaggrConvenzione = filtro.cdRaggrConvenzione;
              self.filter.ndgClientManager = filtro.ndgClientManager;
              self.filter.abi = filtro.abi;
              self.filter.cab = filtro.cab;
              self.filter.iter = filtro.iter;
              self.filter.polo = filtro.polo;

              self.supportModel.praticheSelezionate = [];

              self.listaPraticheSelezionate({
                praticheSelezionate: self.supportModel.praticheSelezionate
              })
              self.getListPractice();
            }
        }
      }

      var convertTypeOfDocument = function (codNsil) {
        switch (codNsil) {
          case '82124':
            return 'Fatture PDF'
          default:
            return;
        }
      }

      var convertDate = function (date) {
        var date = new Date(date).toDateString();
        var convertedDate = moment(date).format('DD/MM/YYYY');
        return convertedDate;
      }

      self.getListPractice = function () {
        self.isPending = true;
        self.restPending({ value: self.isPending });
        if (self.portal === 'ARU') {
          $arcService.practiceListHome(self.filter)
            .then(function (resp) {
              self.listOfTransaction = resp.practices;
              self.listOfTransaction.selected = false;
              self.filter.totalPages = Math.ceil(
                resp.count / 10
              );
              self.isPending = false;
              self.restPending({ value: self.isPending });
            })
            .catch(function () {
              self.isPending = false;
              self.restPending({ value: self.isPending });
            });
        } else {
          $financialService
            .listPractice(self.filter)
            .then(function (resp) {
              self.listOfTransaction = resp.appPracticeDigitalList;
              self.listOfTransaction.selected = false;
              self.filter.totalPages = Math.ceil(
                resp.appPracticeDigitalListCount / 10
              );
              self.isPending = false;
              self.restPending({ value: self.isPending });
            })
            .catch(function () {
              self.isPending = false;
              self.restPending({ value: self.isPending });
            });
        }
      };

      self.getContractsList = function () {
        self.isPending = true;
        self.restPending({ value: self.isPending });
        $arcService
          .getContracts(self.filter)
          .then(function (resp) {
            resp.listContratti.forEach(function (contract) {
              if (contract.dataAvvio && contract.dataAvvio != '-') {
                contract.dataAvvio = moment(contract.dataAvvio).format("DD/MM/YYYY");
              }
              if (contract.dataProssimaScadenzaRata && contract.dataProssimaScadenzaRata != '-') {
                contract.dataProssimaScadenzaRata = moment(contract.dataProssimaScadenzaRata).format("DD/MM/YYYY");
              }
              if (contract.dataFine && contract.dataFine != '-') {
                contract.dataFine = moment(contract.dataFine).format("DD/MM/YYYY")
              }
            });
            self.listOfTransaction = resp.listContratti;
            self.filter.totalPages = Math.ceil(
              resp.totaleContratti / 10
            );
            self.isPending = false;
            self.restPending({ value: self.isPending });
            self.modelToObtainDropdowns = resp;
            self.onObtainingDropdowns({
              value: resp
            });
          })
          .catch(function () {
            self.isPending = false;
            self.restPending({ value: self.isPending });
          });
      };

      self.getDocumentsList = function () {
        self.isPending = true;
        self.restPending({ value: self.isPending });
        if (self.filter.daLeggere) {

          $arcService.archiveToRead(self.filter)
            .then(function (resp) {
              self.listOfTransaction = resp.documents;
              self.listOfTransaction.forEach(function (transaction) {
                transaction.docType = convertTypeOfDocument(transaction.cdDocNsil);
                if (transaction.insertDate && transaction.insertDate != '-') {
                  transaction.insertDate = convertDate(transaction.insertDate);
                }
                if (transaction.updateDate && transaction.updateDate != '-') {
                  transaction.updateDate = convertDate(transaction.updateDate);
                }
              })
              self.filter.totalPages = Math.ceil(
                resp.totaleDocumenti / 10
              );
              self.isPending = false;
              self.restPending({ value: self.isPending });
            })
            .catch(function () {
              self.isPending = false;
              self.restPending({ value: self.isPending });
            });

        } else {
          $arcService
            .getDocuments(self.filter)
            .then(function (resp) {
              self.listOfTransaction = resp.documents;
              self.listOfTransaction.forEach(function (transaction) {
                transaction.docType = convertTypeOfDocument(transaction.cdDocNsil);
                if (transaction.insertDate && transaction.insertDate != '-') {
                  transaction.insertDate = convertDate(transaction.insertDate);
                }
                if (transaction.updateDate && transaction.updateDate != '-') {
                  transaction.updateDate = convertDate(transaction.updateDate);
                }
              })
              self.filter.totalPages = Math.ceil(
                resp.totaleDocumenti / 10
              );
              self.isPending = false;
              self.restPending({ value: self.isPending });
            })
            .catch(function () {
              self.isPending = false;
              self.restPending({ value: self.isPending });
            });
        }

      };

      self.releasePractice = function (id) {
        self.loaderRelease[id] = false;
        $workflowService
          .releasePractice(id)
          .then(function (response) {
            self.loaderRelease[id] = true;
            id = response.id;
            var financialModel = FinancialModel.build(response);
            Object.assign(financialModel, {
              frontEndOptions: response.frontEndOptions,
            });
            $transactionFactory.set(financialModel);
            self.getListPractice();
          })
          .catch(function () {
            self.loaderRelease[id] = false;
          });
      }

      self.deletePractice = function (pratica, index) {
        if (self.actionSelected) {
          return
        }
        self.actionSelected = true;
        self.showModalDelete = true;
        self.loaderElimina[index] = true;
        self.pratica = pratica;
        $timeout(function () {
          $modalService.openModal("modal-confirm");
          self.loaderElimina[index] = false;
        }, 200)
        self.actionSelected = false;
      };

      self.duplicaPratica = function (transactionItem, index) {
        if (self.actionSelected) {
          return
        }
        var idWfInstance = transactionItem.idWf
        self.actionSelected = true;
        self.loaderDuplica[index] = true;
        $workflowService
          .duplicaPratica(idWfInstance)
          .then(function (response) {
            self.loaderDuplica[index] = false;
            idWfInstance = response.idWfInstance;
            var financialModel = FinancialModel.build(response);
            Object.assign(financialModel, {
              frontEndOptions: response.frontEndOptions,
            });
            $transactionFactory.set(financialModel);
            if (financialModel && financialModel.financialCustomer.metadata.riUserG.warningAnagrafica.showPopup) {
              self.warningAnagrafica = financialModel.financialCustomer.metadata.riUserG.warningAnagrafica;
              $modalService.openModal("warningAnagraficaHome-modal");
              self.pratica = {
                id: response.leasingData.id
              }
            } else {
              $location.path("/digitalLeasing");
            }
            self.actionSelected = false;
          })
          .catch(function () {
            self.loaderDuplica[index] = false;
            self.actionSelected = false;
          });
      };

      self.modificaPratica = function (index) {
        self.loaderModifica[index] = true;
        $workflowService
          .resumeInstance(
            self.listOfTransaction[index].idWf,
            type,
            self.listOfTransaction[index].actions.includes("modifica") ?
              "modifica" :
              "modificaDocs"
          )
          .then(function (response) {
            self.loaderModifica[index] = false;
            response.idWfInstance = self.listOfTransaction[index].idWf;
            var financialModel = FinancialModel.build(response)
            Object.assign(financialModel, {
              frontEndOptions: response.frontEndOptions,
            });
            $transactionFactory.set(financialModel);
            $location.path("/digitalLeasing");
            self.actionSelected = false;
          })
          .catch(function () {
            self.loaderModifica[index] = false;
            self.actionSelected = false;
          });
      };

      self.monitorPratica = function (idWf, index) {
        if (self.actionSelected) {
          return
        }
        self.actionSelected = true;
        self.loaderMonitor[index] = true;
        $rootScope.idPracticeSelected = self.listOfTransaction[index].id;
        $workflowService.
          monitorPratica(idWf)
          .then(function (response) {
            Object.assign(response, {
              numeroPreventivo: self.listOfTransaction[index].numeroPreventivo,
              numeroAnno: self.listOfTransaction[index].numeroAnno,
              cdRaggrConvenzione: self.listOfTransaction[index].cdRaggrConvenzione
            })
            $transactionFactory.set(response);
            $location.path("/monitorPratica")
            self.loaderMonitor[index] = false;
            self.actionSelected = false;
          })
          .catch(function (error) {
            console.log("ERRORE:", error);
            self.loaderMonitor[index] = false;
            self.actionSelected = false;
          });
      }

      self.dettaglioContratto = function (numero, modulo) {
        localStorage.setItem("numeroContratto", numero);
        localStorage.setItem("numeroModulo", modulo)
        $location.path("/dettaglioContratto");
      }

      self.confirmSigners = function (fromCloseDuplicate) {
        self.buttonDisabled = true;
        self.loaderConfirm = true;

        if (self.isPostVendita) {
          $RichiestePostVenditaService
            .annullaPracticePv(self.pratica.idWf)
            .then(function () {
              self.getListPractice();
              self.loaderConfirm = false;
              if (fromCloseDuplicate) {
                $modalService.closeModal("warningAnagraficaHome-modal");
              } else {
                $modalService.closeModal("modal-confirm");
              }

              self.buttonDisabled = false;
              self.showModalDelete = false;
            })
            .catch(function () {
              self.loaderConfirm = false;
              self.buttonDisabled = false;
            });
        } else {
          $financialService
            .deletePractice(self.pratica)
            .then(function () {
              self.getListPractice();
              self.loaderConfirm = false;
              if (fromCloseDuplicate) {
                $modalService.closeModal("warningAnagraficaHome-modal");
              } else {
                $modalService.closeModal("modal-confirm");
              }
              self.buttonDisabled = false;
              self.showModalDelete = false;
            })
            .catch(function () {
              self.loaderConfirm = false;
              self.buttonDisabled = false;
            });
        }
      };

      self.pageSIndexIndietro = function (value) {
        if (value == "init") {
          self.filter.pageIndex = 1;
        } else {
          if (self.filter.pageIndex > 1) {
            self.filter.pageIndex--;
          }
        }
        updateOffsetAndSearch();
      };

      self.pageSIndexAvanti = function (value) {
        if (value == "end") {
          //subito pagina finale
          self.filter.pageIndex = self.filter.totalPages;
        } else {
          //avanzo +1
          if (self.filter.pageIndex < self.filter.totalPages) {
            self.filter.pageIndex++;
          }
        }
        updateOffsetAndSearch();
      };

      self.gotoDigital = function (index) {
        if (self.actionSelected) {
          return
        }
        self.actionSelected = true;
        if (!self.listOfTransaction[index].idWf) {
          return;
        }
        $rootScope.idPracticeSelected = self.listOfTransaction[index].id;
        self.loaderRiprendi[index] = true;
        $workflowService
          .resumeInstance(self.listOfTransaction[index].idWf, type)
          .then(function (response) {
            self.loaderRiprendi[index] = false;
            response.idWfInstance = self.listOfTransaction[index].idWf;
            var financialModel = FinancialModel.build(response);
            Object.assign(financialModel, {
              frontEndOptions: response.frontEndOptions,
            });
            $transactionFactory.set(financialModel);
            $location.path("/digitalLeasing");
            self.actionSelected = false;
          })
          .catch(function () {
            self.loaderRiprendi[index] = false;
            self.actionSelected = false;
          })
          .finally(function () {
            self.loaderRiprendi[index] = false;
            self.actionSelected = false;
          });
      };

      self.closeModal = function (value) {
        $modalService.closeModal(value);
        self.showModalDelete = false;
        self.showMoldaDuplicaAutorizza = false;
      };

      self.check = function (el) {
        el.selected = !el.selected;

        if (el.selected) {
          self.supportModel.praticheSelezionate.push(el.id);

          self.listaPraticheSelezionate({
            praticheSelezionate: self.supportModel.praticheSelezionate
          })
        } else {
          const index = self.supportModel.praticheSelezionate.findIndex(function (item) {
            return el === item
          });
          self.supportModel.praticheSelezionate.splice(index, 1);

          self.listaPraticheSelezionate({
            praticheSelezionate: self.supportModel.praticheSelezionate
          })
        }
      }

      self.viewDocuments = function (index) {
        if (self.actionSelected) {
          return
        }
        self.actionSelected = true;
        if (!self.listOfTransaction[index].idWf) {
          console.error(
            "Error! The transaction you picked has no idWfInstance, we can't resume it!",
            self.listOfTransaction[index].idWf
          );
          return;
        }
        self.loaderViewDocs[index] = true;
        $workflowService
          .resumeViewDocsDigital(self.listOfTransaction[index].idWf, type)
          .then(function (response) {
            self.loaderViewDocs[index] = false;
            response.idWfInstance = self.listOfTransaction[index].idWf;
            var financialModel = FinancialModel.build(response);
            Object.assign(financialModel, {
              frontEndOptions: response.frontEndOptions,
            });
            $transactionFactory.set(financialModel);
            $rootScope.openModalViewDocs = true;
            $timeout(function () {
              $modalService.openModal("viewDocuments");
            }, 100)
            self.actionSelected = false;
          })
          .catch(function (error) {
            self.loaderViewDocs[index] = false;
            console.log("La chiamata è andata in errore:", error);
            self.actionSelected = false;
          })
      };

      self.generateDownloadFatt = function (idFattura) {
        var idFatturaMod = idFattura && idFattura.replace(/\//g, "-");
        var url = "/arc/downloadDocumentFattura/service-infos/" +
          encodeURIComponent(idFatturaMod) +
          "/";

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      }

      self.generateDownloadMoreDocs = function (idDocAlbagreen, cdDocNsil) {
        var url = "/arc/downloadDocument/service-infos/" +
          encodeURIComponent(idDocAlbagreen) +
          "/" +
          encodeURIComponent(cdDocNsil) +
          "/"

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })

      }

      self.dettaglio_Pv = function (idWf, index) {
        self.loaderDettaglioPv[index] = true;
        $arcService.getAllDocumentsPv(idWf)
          .then(function (response) {
            if (response.success) {
              $rootScope.openModalDetailsPV = true;
              if (!response.printedDocs.length && !response.uploadedDocs.length && !response.albaGreenDocs.length) {
                $rootScope.$broadcast("addAlert", {
                  text: "DO_NOT_PRACTICE_DETAIL"
                })
              } else {
                $transactionFactory.set(response);
                $timeout(function () {
                  $modalService.openModal("modalDetailsPv");
                }, 100)
              }

            }
            self.loaderDettaglioPv[index] = false;

          })
          .catch(function (error) {
            self.loaderDettaglioPv[index] = false;
          })
      }

      self.dettaglio = function (id, index) {
        self.loaderDettaglioPv[index] = true;

        $financialApiService.dettaglioRichiestaPv(id)
          .then(function (response) {
            self.loaderDettaglioPv[index] = false;
            response.readOnly = true;
            var richiestePostVenditaModel = RichiestePostVendita.build(response);
            $transactionFactory.set(richiestePostVenditaModel);
            $location.path(response.targetView)
          })
          .catch(function () {
            self.loaderDettaglioPv[index] = false;
          })
      }

      self.hFpractice = function (id, modal) {
        self.contractId = id;
        $transactionFactory.set(self.contractId);
        $modalService.openModal('hoFinito-modal');
      }

      self.stipulaPractice = function (practice, modal) {
        self.stipulaId = practice.id;
        $transactionFactory.set(practice);
        $location.path('/stipulaDigital')

      }


      self.resumePostVendita = function (index) {
        var selectedPractice = self.listOfTransaction[index];
        self.loaderRiprendiPv[index] = true;
        $RichiestePostVenditaService.resumeInstance(selectedPractice.idWf, selectedPractice.wfType, selectedPractice.wfApplicationName)
          .then(function (response) {
            response.idWf = selectedPractice.idWf;
            response.fromResume = true;
            $transactionFactory.set(response);
            $location.path(response.route);
            self.loaderRiprendiPv[index] = false;
          })
          .catch(function (error) {
            console.log(error);
            self.loaderRiprendiPv[index] = false;
          })


      }

      self.isRowSelected = function (index) {
        var indexPractice = self.listOfTransaction
          .findIndex(function (element) {
            return element.id == $rootScope.idPracticeSelected;
          })

        return !!(indexPractice == index);
      }

      self.updateOrderTableSimulation = function (ordColName, ordType) {
        self.filter.orderColumnName = ordColName;
        self.filter.orderType = ordType;
        self.getListPractice();
      }

      self.taskFiliale = function (index) {
        if (!self.listOfTransaction[index].idWf) {
          return;
        }
        $rootScope.idPracticeSelected = self.listOfTransaction[index].id;
        self.loaderTaskFiliale[index] = true;
        $workflowService
          .resumeTaskFiliale(self.listOfTransaction[index].idWf, type)
          .then(function (response) {
            self.loaderTaskFiliale[index] = false;
            response.idWfInstance = self.listOfTransaction[index].idWf;
            var financialModel = FinancialModel.build(response);
            Object.assign(financialModel, {
              frontEndOptions: response.frontEndOptions
            });
            $transactionFactory.set(financialModel);
            $location.path("/digitalLeasing");
          })
          .catch(function () {
            self.loaderTaskFiliale[index] = false;
          });
      }

      self.deletePracticePv = function (pratica, index) {
        self.showModalDelete = true;
        self.isPostVendita = true;
        self.loaderEliminaPv[index] = true;
        self.pratica = pratica;
        $timeout(function () {
          $modalService.openModal("modal-confirm");
          self.loaderEliminaPv[index] = false;
        }, 500)

      };

      self.duplicaAutorizza = function () {
        if (self.actionSelected) {
          return
        }
        self.actionSelected = true;
        self.loaderConfirmDuplicaAutorizza = true;
        self.loaderDuplicaAutorizza[self.indexPracticeSelected] = true;
        $workflowService
          .duplicaAutorizza(self.idWfInstancePracticeSelected)
          .then(function (response) {
            self.loaderDuplicaAutorizza[self.indexPracticeSelected] = false;
            var financialModel = FinancialModel.build(response);
            Object.assign(financialModel, {
              frontEndOptions: response.frontEndOptions,
            });
            $transactionFactory.set(financialModel);
            self.showMoldaDuplicaAutorizza = false;
            self.loaderConfirmDuplicaAutorizza = false;
            $modalService.closeModal('modal-duplicaAutorizza');
            $location.path("/digitalLeasing");
            self.actionSelected = false;
          })
          .catch(function () {
            self.loaderDuplicaAutorizza[self.indexPracticeSelected] = false;
            self.loaderConfirmDuplicaAutorizza = false;
            self.actionSelected = false;
          });
      };

      self.duplicaAutorizzaCheck = function (idWfInstance, index) {
        self.loaderDuplicaAutorizza[index] = true;
        self.idWfInstancePracticeSelected = idWfInstance;
        self.indexPracticeSelected = index;
        if (self.listOfTransaction[index] && self.listOfTransaction[index].numeroContratto) {
          self.duplicaAutorizza()
        } else {
          self.showMoldaDuplicaAutorizza = true;
          $timeout(function () {
            $modalService.openModal('modal-duplicaAutorizza');
            self.loaderDuplicaAutorizza[index] = false;
          }, 500)
        }
      }
      self.checkResultToAssign = function (item) {
        if (item.assignDescr) {
          return item.assignDescr;
        } else if (item.assignToUser) {
          return item.assignToUser;
        } else if (item.assignToUserNdg) {
          return item.assignToUserNdg;
        } else if (item.assignToGroup) {
          return item.assignToGroup;
        }
      }

      self.markAsReaded = function (transactionItem) {
        transactionItem.daLeggere = false;
      }


      self.modificaRicPreventivo = function (index) {
        $transactionFactory.set(self.listOfTransaction[index]);
        $rootScope.showmodalModificaPreventivo = true;
        $timeout(function () {

          $modalService.openModal('modal-modificaRichiestaPreventivo');
        }, 200)
      }

      self.goToCopied = function () {

        $modalService.closeModal("warningAnagraficaHome-modal");
        $location.path("/digitalLeasing");

      }

      self.copyRequestPv = function (index) {
        self.loaderCopyRequestPv[index] = true;
        self.idRichiesta = self.listOfTransaction[index].idRichiesta;
        $arcService
          .getContracts()
          .then(function (response) {
            if (response.success) {
              self.supportModel.listaContratti = response.listContratti;
              self.supportModel.listaContrattiDaDuplicare = self.supportModel.listaContratti.filter(function (x) {
                return x.numeroContratto != self.listOfTransaction[index].contrattoRichiesta
              })
              $modalService.openModal("modal-duplicaContratto");
              self.loaderCopyRequestPv[index] = false;
            } else {
              self.loaderCopyRequestPv[index] = false;
            }
          })
          .catch(function (error) {
            self.loaderCopyRequestPv[index] = false;
          });
      };

      self.selectContract = function (value) {
        self.supportModel.contrattiSelezionati = [];
        if (value) {
          self.supportModel.contrattiSelezionati.push(value);
        }
      };

      self.duplicaContratto = function () {
        self.loaderDuplicaContratto = true;
        $arcService
          .copyRequestPv(
            self.supportModel.contrattiSelezionati,
            self.idRichiesta,
            null, null
          )
          .then(function (response) {
            console.log("response copyRequestPv -->", response);
            self.loaderDuplicaContratto = false;
            if (response && response.metadata && response.route) {
              response.metadata.ctrRichiestaList = self.supportModel.contrattiSelezionati
              $transactionFactory.set(response);
              if (response.route == "/assistenzaTecnica") {
                $rootScope.$broadcast("addAlert", {
                  text: "REQUEST_PV_SUBMITTED",
                });
              } else {
                $location.path(response.route);
              }
            } else {
              $rootScope.$broadcast("addAlert", {
                text: "REQUEST_PV_SUBMITTED",
              });
            }
            $modalService.closeModal("modal-duplicaContratto");
          })
          .catch(function () {
            self.loaderDuplicaContratto = false;
            $modalService.closeModal("modal-duplicaContratto");
          });
      };


    }


  });